import { render, staticRenderFns } from "./OrderButton.vue?vue&type=template&id=bf535b56&scoped=true"
import script from "./OrderButton.vue?vue&type=script&lang=js"
export * from "./OrderButton.vue?vue&type=script&lang=js"
import style0 from "./OrderButton.vue?vue&type=style&index=0&id=bf535b56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf535b56",
  null
  
)

export default component.exports